var IonicNativePlugin = (function () {
    function IonicNativePlugin() {
    }
    /**
     * Returns a boolean that indicates whether the plugin is installed
     * @return {boolean}
     */
    /**
       * Returns a boolean that indicates whether the plugin is installed
       * @return {boolean}
       */
    IonicNativePlugin.installed = /**
       * Returns a boolean that indicates whether the plugin is installed
       * @return {boolean}
       */
    function () {
        return false;
    };
    /**
     * Returns the original plugin object
     */
    /**
       * Returns the original plugin object
       */
    IonicNativePlugin.getPlugin = /**
       * Returns the original plugin object
       */
    function () { };
    /**
     * Returns the plugin's name
     */
    /**
       * Returns the plugin's name
       */
    IonicNativePlugin.getPluginName = /**
       * Returns the plugin's name
       */
    function () {
        return;
    };
    /**
     * Returns the plugin's reference
     */
    /**
       * Returns the plugin's reference
       */
    IonicNativePlugin.getPluginRef = /**
       * Returns the plugin's reference
       */
    function () {
        return;
    };
    /**
     * Returns the plugin's install name
     */
    /**
       * Returns the plugin's install name
       */
    IonicNativePlugin.getPluginInstallName = /**
       * Returns the plugin's install name
       */
    function () {
        return;
    };
    /**
     * Returns the plugin's supported platforms
     */
    /**
       * Returns the plugin's supported platforms
       */
    IonicNativePlugin.getSupportedPlatforms = /**
       * Returns the plugin's supported platforms
       */
    function () {
        return;
    };
    return IonicNativePlugin;
}());
export { IonicNativePlugin };
//# sourceMappingURL=ionic-native-plugin.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ionic-native/core/ionic-native-plugin.js
// module id = 275
// module chunks = 7